import { LaminatedCardApplePayCreationDto } from '../dtos/laminated-card-apple-pay.dto';
import { LaminatedCardApplePayCreation } from '../models/laminated-card-apple-pay';

/**
 * Map data to dto.
 * @param {LaminatedCardApplePayCreation} data Data
 * @returns {LaminatedCardApplePayCreationDto}
 */
function toCreationDto(data) {
  return {
    applePayData: data.applePayData,
  };
}

export const laminatedCardApplePayMapper = {
  toCreationDto,
};
